import { atom } from "jotai";

export * from "./PlacesInput";
export * from "./PlacesInput2";

export const accommodationNameAtom = atom("");
